import React from 'react';
import Context from '../../Context';
import AuditTimeline from './AuditTimeline';
import AuditAlerts from '../../components/AuditAlerts';
export default function LogList() {
  const { profileState } = Context();
  if (profileState?.role !== 'dev') return <p role="alert">Dev access required</p>;
  return <><AuditAlerts /><AuditTimeline /></>;
}
